<template>
  <Modal title="Pré-visualização do vídeo" :width="720" :height="450" v-if="showModal('nixiaVideoPreview')">
    <div class="nixia-video-preview-wrapper">
      <iframe
        v-if="videoPreviewUrl"
        :src="videoPreviewUrl"
        class="nixia-video-preview-iframe"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/ui/forms/Modal";
import { mapGetters, mapState } from "vuex";

export default {
  name: "NixiaVideoPreviewModal",
  components: { Modal },
  computed: {
    ...mapGetters("generic", ["showModal"]),
    ...mapState("nixia", ["videoPreviewUrl"]),
  },
};
</script>

<style scoped>
.nixia-video-preview-wrapper {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
}

.nixia-video-preview-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
}
</style>
